import styled from "styled-components";

export const RingSvg = styled.svg`
  flex-shrink: 0;
`;
